/**
 * Creates a hidden input element for form submission
 */
export const createHiddenFormInput = (name, value, target) => {
  const input = document.createElement('INPUT')
  input.type = 'hidden'
  input.name = name
  input.value = value
  input.target = target
  return input
}

/**
 * Creates a hidden form with the given URL, meta data, and params
 */
export const createHiddenForm = (url, meta, params, target) => {
  const form = document.createElement('FORM')
  form.method = 'post'
  form.action = url
  form.target = target

  for (const [key, value] of Object.entries(meta)) {
    if (Array.isArray(value)) {
      for (const arrElement of value) {
        form.appendChild(createHiddenFormInput(`${key}[]`, arrElement, target))
      }
    } else {
      form.appendChild(createHiddenFormInput(key, value, target))
    }
  }

  for (const [, v] of Object.entries(params)) {
    const p = v.split('=')
    form.appendChild(createHiddenFormInput(p[0], p[1], target))
  }

  return form
}

/**
 * Creates and submits a hidden form, optionally in an iframe
 */
export const submitHiddenForm = (url, meta, params = {}, target = '_blank') => {
  if (target && !['_blank', '_self'].includes(target)) {
    const existingIframe = document.querySelector(`#${target}`)
    if (existingIframe) {
      existingIframe.parentNode.removeChild(existingIframe)
    }

    const iframe = document.createElement('iframe')
    iframe.src = 'javascript:false;'
    iframe.name = target
    iframe.id = target
    iframe.style.display = 'none'
    document.body.insertBefore(iframe, document.body.firstChild)
  }

  const form = createHiddenForm(url, meta, params, target)
  document.body.appendChild(form)
  form.submit()

  setTimeout(() => {
    if (form.parentNode) {
      form.parentNode.removeChild(form)
    }
  }, 0)
}

let measureContext

/**
 * The width a line of text takes in the given CSS font, measured on a canvas so that nothing on the
 * page is laid out to answer it. Null where there is no canvas to measure on (no document, or a DOM
 * without a 2D context), so a caller can say what an unmeasured label does.
 */
export const measureTextWidth = (text, font) => {
  if ('undefined' == typeof document) return null

  measureContext ||= document.createElement('canvas').getContext?.('2d') || null
  if (!measureContext) return null

  measureContext.font = font
  return measureContext.measureText(text || '').width
}
